import { MessageService } from '@progress/kendo-angular-l10n';
import { Injectable } from "@angular/core";
const messages = {
  'kendo.grid.noRecords': 'رکورد وجود ندارد.',
  'kendo.grid.groupPanelEmpty': 'یک سر ستون را بکشید و آن را در اینجا رها کنید تا توسط آن ستون گروه بندی شود',
};
@Injectable()
export class SepidzMessageService extends MessageService {
  public get(key: string): string {
    return this.getMessage(key);
  }
  getMessage(key: string) {
    var message: string;
    switch (key) {
      case 'kendo.grid.groupPanelEmpty': message = 'یک سر ستون را بکشید و آن را در اینجا رها کنید تا توسط آن ستون گروه بندی شود';
        break;
      case 'kendo.treelist.noRecords':
      case 'kendo.grid.noRecords': message = 'رکورد وجود ندارد';
        break;
      case 'kendo.grid.pagerFirstPage': message = 'صفحه اول';
        break;
      case 'kendo.grid.pagerPreviousPage': message = 'صفحه قبل';
        break;
      case 'kendo.grid.pagerNextPage': message = 'صفحه بعد';
        break;
      case 'kendo.grid.pagerLastPage': message = 'صفحه آخر';
        break;
      case 'kendo.grid.pagerPage': message = 'صفحه';
        break;
      case 'kendo.grid.pagerOf': message = 'از';
        break;
      case 'kendo.grid.pagerItems': message = 'قلم';
        break;
      case 'kendo.grid.pagerItemsPerPage': message = 'قلم در صفحه';
        break;
      case 'kendo.grid.filter': message = 'فیلتر';
        break;
      case 'kendo.grid.filterEqOperator': message = 'مساوی با';
        break;
      case 'kendo.grid.filterNotEqOperator': message = 'نا مساوی';
        break;
      case 'kendo.grid.filterIsNullOperator': message = 'تهی';
        break;
      case 'kendo.grid.filterIsNotNullOperator': message = 'غیر تهی';
        break;
      case 'kendo.grid.filterIsEmptyOperator': message = 'خالی';
        break;
      case 'kendo.grid.filterIsNotEmptyOperator': message = 'خالی نباشد';
        break;
      case 'kendo.grid.filterStartsWithOperator': message = 'شروع شود با';
        break;
      case 'kendo.grid.filterContainsOperator': message = 'شامل';
        break;
      case 'kendo.grid.filterNotContainsOperator': message = 'شامل نباشد';
        break;
      case 'kendo.grid.filterEndsWithOperator': message = 'تمام شود با';
        break;
      case 'kendo.grid.filterGteOperator': message = 'بزرکترمساوی';
        break;
      case 'kendo.grid.filterGtOperator': message = 'بزرگتر';
        break;
      case 'kendo.grid.filterLteOperator': message = 'کوچکترمساوی';
        break;
      case 'kendo.grid.filterLtOperator': message = 'کوچکتر';
        break;
      case 'kendo.grid.filterIsTrue': message = 'درست';
        break;
      case 'kendo.grid.filterIsFalse': message = 'نادرست';
        break;
      case 'kendo.grid.filterBooleanAll': message = 'همه';
        break;
      case 'kendo.grid.filterAfterOrEqualOperator': message = 'بعداز یامساوی با';
        break;
      case 'kendo.grid.filterAfterOperator': message = 'بعد از';
        break;
      case 'kendo.grid.filterBeforeOperator': message = 'قبل از';
        break;
      case 'kendo.grid.filterBeforeOrEqualOperator': message = 'قبل از یا برابر با';
        break;
      case 'kendo.grid.filterFilterButton': message = 'فیلتر';
        break;
      case 'kendo.grid.filterClearButton': message = 'پاک';
        break;
      case 'kendo.grid.filterAndLogic': message = 'و';
        break;
      case 'kendo.grid.filterOrLogic': message = 'یا';
        break;
      case 'kendo.grid.loading': message = 'در حال بارگذاری';
        break;
      case 'kendo.grid.sort': message = 'مرتب';
        break;
      case 'kendo.grid.columnMenu': message = 'منو ستون';
        break;
      case 'kendo.grid.columns': message = 'ستونها';
        break;
      case 'kendo.grid.lock': message = 'قفل کردن';
        break;
      case 'kendo.grid.unlock': message = 'بازکردن';
        break;
      case 'kendo.grid.sortedAscending': message = 'به ترتیب صعودی';
        break;
      case 'kendo.grid.sortedDescending': message = 'به ترتیب نزولی';
        break;
      case 'kendo.grid.columnsApply': message = 'اعمال';
        break;
      case 'kendo.grid.columnsReset': message = 'تنظیم مجدد';
        break;
      case 'kendo.grid.sortable': message = 'مرتب کردن';
        break;
      case 'kendo.grid.sortAscending': message = 'به ترتیب صعودی';
        break;
      case 'kendo.grid.sortDescending': message = 'به ترتیب نزولی';
        break;
      case 'kendo.grid.sortedDefault': message = 'به ترتیب پیش فرض';
        break;
      case 'kendo.dropdownlist.noDataText':
      case 'kendo.autocomplete.noDataText':
         message = 'اطلاعاتی جهت انتخاب وجود ندارد.';
        break;
      default:
        message = key;
        break;
    }
    return message;
  }
}
